export default __webpack_public_path__ + "static/media/error-1.e4374db7.png";